import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useState } from "react";
import { RouteComponentProps } from "react-router-dom";
import { Row } from "reactstrap";
import { RootStoreContext } from "../app/stores/rootStore";
import GenericBrowsePageResizeHelper from "../components/common/GenericBrowsePageResizeHelper";
import Loader from "../components/common/Loader";
import GenericTeletabberGallery from "../components/gallery/GenericTeletabberGallery";
import TitleNavbar from "../components/navbars/TitleNavbar";
import ToolbarSelector from "../components/navbars/ToolbarSelector";

interface IParams {
  archiveId: string;
  contentId: string;
}

const ArchiveBrowsePage: React.FC<RouteComponentProps<IParams>> = ({
  match,
  location,
  history,
}) => {
  const rootStore = useContext(RootStoreContext);
  const { loadPresentationDetails } = rootStore.presentationStore;
  const { currentBrowsePageContent, selectedLanguageId, resetBrowsePage } =
    rootStore.commonStore;
  const { attendingMeeting } = rootStore.playerStore;
  const { errorUrl } = rootStore.tenantStore;
  const { GetArchiveBrowsePageDetails } = rootStore.archiveStore;
  const { destroyZwibblerContext } = rootStore.zwibblerStore;
  const [galleryStartingPage, setGalleryStartingPage] = useState(0);

  useEffect(() => {
    const archiveId = parseInt(match.params.archiveId);
    const contentId = parseInt(match.params.contentId);
    if (archiveId && contentId) {
      const urlParams = new URLSearchParams(location.search);
      //gallery page
      const page = urlParams.get("pag") ?? "";
      let intPage = parseInt(page);
      setGalleryStartingPage(intPage);
      GetArchiveBrowsePageDetails(archiveId,contentId)
        .then()
        .catch(() => history.push(errorUrl));
    } else history.push(errorUrl);

    return () => {
      resetBrowsePage();
      destroyZwibblerContext();
    };
  }, [location.search, errorUrl, history, resetBrowsePage, destroyZwibblerContext, GetArchiveBrowsePageDetails, match.params.archiveId, match.params.contentId]);

  if (!currentBrowsePageContent) return <Loader />;

  return (
    <>
      <GenericBrowsePageResizeHelper />
      <Row>
        <TitleNavbar title={currentBrowsePageContent.title.document} />
      </Row>
      <Row>
        <ToolbarSelector
          items={currentBrowsePageContent.items}
          isSidebarOpen={true}
          stickyButton="share"
        />
      </Row>
      <Row>
        <GenericTeletabberGallery
          items={currentBrowsePageContent.items}
          startingPage={galleryStartingPage}
        />
      </Row>
    </>
  );
};

export default observer(ArchiveBrowsePage);
